import './scss/main.scss';

'use strict';
// YOUR JS code HERE


/* JS Start when Document Load & DOM build*/
document.addEventListener('DOMContentLoaded', ready);
function ready() {



};

/* JS Start when Document Load & DOM build & All Scripts and Images Load*/
window.onload = function() {
    console.log("test enqueue js scripts");
};

/* ==========================================================================
* jQuery Scripts
* ========================================================================== */
(function($, undefined, window){
    $(document).ready(function(){


        console.log('jquery');


    });
})(jQuery, window);